import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { useState, useEffect } from "react";
import { faTrashAlt, faPencilAlt, faDownload, faPlus } from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";

import withName from "../../hoc/withName";
import LoadingDialog from "../Utils/LoadingDialog";
import { FilterMatchMode } from "primereact/api";


const DataTablePrime = ({t, items, fields, filters,header, tableName, editableRow, extra_option=null,reorderable,selectionMode,rowDataBoundFunction,rowDataBoundConstraints=null, deletableRow,dynamicColumns, exportFunction, loading,editFunction,removableSort=null,expandableRowGroups=null, editButtonProps,deleteFunction, ...dataTableprops}) => {

    const [globalFiltervalue, setGlobalFilterValue] = useState(null);
    const [globalFilters, setGlobalFilters] = useState(filters);
    const [customFilterNodes, setCustomFiltersNodes] = useState(null);
    const [expandedRows, setExpandedRows] = useState([]);
    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        const _filters = { ...filters };
        if(_filters?.n_cliente_id){
            if(/^\d+$/.test(value)){
                const newNodes = items?.filter(i => i?.n_cliente_id === parseInt(value));
                setCustomFiltersNodes(newNodes);
            }else{
                setCustomFiltersNodes(null);
            }
        }
        _filters.global.value = value;
        setGlobalFilters(_filters);
        setGlobalFilterValue(value);
    };
    const renderSearchHeader = () => {
        return (
            <div className="flexDisplay justify-content-end">
                <div>
                    <div className="p-inputgroup flex-1">
                        <InputText type="search" className="inputHeaderTable" onInput={onGlobalFilterChange} placeholder={t("forms.search")} />
                        <span className="p-inputgroup-addon inputIconTables inputHeaderTable">
                            <i className="pi pi-search" />
                        </span>
                    </div>
                </div>
            </div>
        );
    };
    const searchHeader = renderSearchHeader();

    const renderExportHeader = () => {
        return (
            <div className="flexDisplay justify-content-end">
                <div>
                    <div className="p-inputgroup flex-1">
                        <Button type="button" rounded text aria-label="Delete" style={{color:"#FFFFFF"}} onClick={exportFunction} >
                            <FontAwesomeIcon  icon={faDownload} size="lg" />
                        </Button>
                    </div>
                </div>
            </div>
        );
    };
    const exportHeader = renderExportHeader();

    const btnsTemplate = (rowData, editableRow, deletableRow, rowDataBoundFunction,extra_option, rowDataBoundConstraints) => {
        let permission = true;
        if(rowDataBoundFunction) {
            permission = rowDataBoundFunction(rowData);
        }
        return(
            <>
                {
                    permission?
                        <>
                            {
                                extra_option?
                                    <Button type="button" rounded text aria-label="Edit" severity="secondary" onClick={(event) => {
                                        if(extra_option.function){
                                            extra_option.function(event, rowData);
                                        }
                                    }} {...editButtonProps}
                                    >
                                        {extra_option.icon}
                                    </Button>

                                    :null
                            }
                            {
                                editableRow?
                                    <Button type="button" rounded text aria-label="Edit" severity="secondary" onClick={(event) => {
                                        if(editFunction){
                                            editFunction(event, rowData);
                                        }
                                    }} {...editButtonProps}
                                    >
                                        <FontAwesomeIcon icon={faPencilAlt} size="lg" />
                                    </Button>
                                    :null
                            }
                            {
                                deletableRow?
                                    <Button type="button" rounded text aria-label="Delete" severity="danger" onClick={(event) => {
                                        deleteFunction(event, rowData);
                                    }}
                                    >
                                        <FontAwesomeIcon  icon={faTrashAlt} size="lg" />
                                    </Button>
                                    :null
                            }
                        </>
                        :rowDataBoundConstraints?.type==="disabled"?
                            <>
                                {
                                    extra_option?
                                        <Button
                                            disabled={rowDataBoundConstraints?.on?.includes("extra_option")}
                                            tooltip={rowDataBoundConstraints?.on?.includes("extra_option")? rowDataBoundConstraints?.tooltip :undefined}
                                            tooltipOptions={{ showOnDisabled: true, position: "top", style: { fontSize: "12px", fontFamily: "Montserrat" } }}
                                            type="button" rounded text aria-label="Edit" severity="secondary" onClick={(event) => {
                                                if(extra_option.function){
                                                    extra_option.function(event, rowData);
                                                }
                                            }} {...editButtonProps}
                                        >
                                            {extra_option.icon}
                                        </Button>

                                        :null
                                }
                                {
                                    editableRow?
                                        <Button
                                            disabled={rowDataBoundConstraints?.on?.includes("editableRow")}
                                            tooltip={rowDataBoundConstraints?.on?.includes("editableRow")? rowDataBoundConstraints?.tooltip :undefined}
                                            tooltipOptions={{ showOnDisabled: true, position: "top", style: { fontSize: "12px", fontFamily: "Montserrat" } }}
                                            type="button" rounded text aria-label="Edit" severity="secondary" onClick={(event) => {
                                                if(editFunction){
                                                    editFunction(event, rowData);
                                                }
                                            }} {...editButtonProps}
                                        >
                                            <FontAwesomeIcon icon={faPencilAlt} size="lg" />
                                        </Button>
                                        :null
                                }
                                {
                                    deletableRow?
                                        <Button
                                            disabled={rowDataBoundConstraints?.on?.includes("deletableRow")}
                                            tooltip={rowDataBoundConstraints?.on?.includes("deletableRow")? rowDataBoundConstraints?.tooltip :undefined}
                                            type="button" rounded text aria-label="Delete" severity="danger" onClick={(event) => {
                                                deleteFunction(event, rowData);
                                            }}
                                        >
                                            <FontAwesomeIcon  icon={faTrashAlt} size="lg" />
                                        </Button>
                                        :null
                                }
                            </>
                            :null
                }
            </>);
    };
    return (
        <>
            {loading?<LoadingDialog />:null}
            <DataTable
                className="dataTablePrime" value={customFilterNodes?customFilterNodes:items} scrollable={dataTableprops.scrollHeight?true:false} removableSort={removableSort !== null?removableSort:true}
                rowClassName={`dataTablePrimeRows ${selectionMode?"selectableRow":""}`} selectionMode={selectionMode} header={
                    header==="search"?
                        searchHeader
                        :header==="exportTable"?
                            exportHeader
                            :null
                }
                filters={globalFilters} globalFilter={globalFiltervalue}
                expandableRowGroups={expandableRowGroups} expandedRows={expandableRowGroups?expandedRows:null}
                onRowToggle={expandableRowGroups?(e) => setExpandedRows(e.data):null}
                {...dataTableprops}
            >
                {reorderable?<Column key={`${0}-${tableName}`} rowReorder style={{ width: "3rem", textAlign:"center" }} headerClassName="dataTablePrimeHeader" />:null}
                {selectionMode==="checkbox"?<Column key={`${1}-${tableName}`} selectionMode="multiple" style={{paddingLeft:"1rem"}} headerStyle={{ width: "3rem", paddingLeft:"0" }} headerClassName="dataTablePrimeHeader" />:null}
                {dynamicColumns}
                {fields?.map((col, i) => {
                    if (!col.hidden) {
                        return (
                            <Column
                                key={`${i+2}-${tableName}`}
                                headerClassName="dataTablePrimeHeader"
                                {...col}
                                bodyStyle={{textAlign:"center",...col.bodyStyle}}
                                headerStyle={{textAlign:"center",...col.headerStyle}}
                            />
                        );
                    }
                    else{
                        return null;
                    }
                })}
                {editableRow || deletableRow || extra_option?<Column header={t("forms.opciones")} headerClassName="dataTablePrimeHeader" body={(e) => btnsTemplate(e, editableRow, deletableRow, rowDataBoundFunction,extra_option, rowDataBoundConstraints)}  bodyStyle={{display:"flex", justifyContent:"center"}} />:null}
            </DataTable>
        </>
    );
};

export default withName(DataTablePrime, "DataTablePrime");
